import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';

import { PaySignUpButton } from 'components/dutchie-pay';

import {
  CheckoutLabel,
  CheckoutLabelGrouping,
  CheckoutBody,
  CheckoutSectionHeading,
} from 'checkout/components/styles/common';
import { PayButtonPosition } from 'components/dutchie-pay/pay-sign-up-button/pay-sign-up-button';

export type ExpressCheckoutProps = {
  textPosition?: PayButtonPosition;
};

// eslint-disable-next-line i18next/no-literal-string
export function ExpressCheckout({ textPosition = 'bottom' }: ExpressCheckoutProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <CheckoutLabelGrouping id='express-checkout' marginBottom='29px'>
        <CheckoutLabel>
          <CheckoutSectionHeading>{t('payment.express-checkout', 'Express Checkout')}</CheckoutSectionHeading>
        </CheckoutLabel>
        <CheckoutBody>
          <PaySignUpButtonContainer>
            <PaySignUpButton textPosition={textPosition} />
          </PaySignUpButtonContainer>
        </CheckoutBody>
      </CheckoutLabelGrouping>
    </React.Fragment>
  );
}

const PaySignUpButtonContainer = styled.div`
  max-width: 390px;
`;
